import { render } from "./DocInfo.vue?vue&type=template&id=130447f0&scoped=true"
import script from "./DocInfo.vue?vue&type=script&lang=js"
export * from "./DocInfo.vue?vue&type=script&lang=js"

import "./DocInfo.vue?vue&type=style&index=0&id=130447f0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130447f0"]])

export default __exports__